import { getSectionDefaults } from './sectionDefaults';

// Comprehensive Business Category Templates
export const BUSINESS_TEMPLATES = [
  // 1. Restaurant & Food
  {
    id: 'restaurant',
    category: 'Food & Dining',
    name: 'Restaurant',
    description: 'Perfect for restaurants, cafes, and food businesses',
    preview: '🍽️',
    color: '#f59e0b',
    sections: [
      { id: 'hero-1', type: 'hero', content: { heading: 'Welcome to Our Restaurant', subheading: 'Experience authentic flavors and exceptional dining', buttonText: 'View Menu', buttonLink: '#services', backgroundImage: 'https://images.pexels.com/photos/1199957/pexels-photo-1199957.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'about-1', type: 'about', content: { heading: 'Our Story', text: 'For over 20 years, we\'ve been serving delicious, authentic cuisine made with the freshest ingredients.' }},
      { id: 'services-1', type: 'services', content: { heading: 'Our Menu', items: [{ icon: '🍕', title: 'Fresh Pizza', description: 'Wood-fired pizzas' }, { icon: '🍝', title: 'Pasta', description: 'Homemade daily' }, { icon: '🥗', title: 'Salads', description: 'Fresh ingredients' }]}},
      { id: 'gallery-1', type: 'gallery', content: { heading: 'Our Dishes' }},
      { id: 'testimonials-1', type: 'testimonials', content: { heading: 'Happy Customers' }},
      { id: 'contact-1', type: 'contact', content: { heading: 'Visit Us Today' }}
    ]
  },

  // 2. Fitness & Gym
  {
    id: 'fitness',
    category: 'Health & Fitness',
    name: 'Fitness Center',
    description: 'Ideal for gyms, fitness studios, and personal trainers',
    preview: '💪',
    color: '#ef4444',
    sections: [
      { id: 'hero-2', type: 'hero', content: { heading: 'Transform Your Body', subheading: 'Join the #1 fitness center in town', buttonText: 'Start Free Trial', buttonLink: '#pricing', backgroundImage: 'https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'features-1', type: 'features', content: { heading: 'Why Choose Us', features: [{ icon: '🏋️', title: 'Expert Trainers', description: 'Certified professionals' }, { icon: '⚡', title: 'Modern Equipment', description: 'State-of-the-art facilities' }, { icon: '📅', title: 'Flexible Hours', description: 'Open 24/7' }]}},
      { id: 'services-2', type: 'services', content: { heading: 'Our Classes', items: [{ icon: '🧘', title: 'Yoga', description: 'Mind & body wellness' }, { icon: '🥊', title: 'Boxing', description: 'High-intensity training' }, { icon: '🏃', title: 'Cardio', description: 'Fat burning workouts' }]}},
      { id: 'pricing-1', type: 'pricing', content: { heading: 'Membership Plans' }},
      { id: 'team-1', type: 'team', content: { heading: 'Meet Our Trainers' }},
      { id: 'newsletter-1', type: 'newsletter', content: { heading: 'Get Fitness Tips' }},
      { id: 'contact-2', type: 'contact', content: { heading: 'Get Started Today' }}
    ]
  },

  // 3. Beauty Salon & Spa
  {
    id: 'beauty',
    category: 'Beauty & Wellness',
    name: 'Beauty Salon',
    description: 'Perfect for salons, spas, and beauty professionals',
    preview: '💅',
    color: '#ec4899',
    sections: [
      { id: 'hero-3', type: 'hero', content: { heading: 'Pamper Yourself', subheading: 'Experience luxury beauty treatments', buttonText: 'Book Now', buttonLink: '#services', backgroundImage: 'https://images.pexels.com/photos/3065209/pexels-photo-3065209.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'services-3', type: 'services', content: { heading: 'Our Services', items: [{ icon: '💇', title: 'Hair Styling', description: 'Expert cuts & color' }, { icon: '💅', title: 'Nail Care', description: 'Manicure & pedicure' }, { icon: '✨', title: 'Facials', description: 'Rejuvenating treatments' }]}},
      { id: 'gallery-2', type: 'gallery', content: { heading: 'Our Work' }},
      { id: 'pricing-2', type: 'pricing', content: { heading: 'Service Packages' }},
      { id: 'testimonials-2', type: 'testimonials', content: { heading: 'Client Reviews' }},
      { id: 'contact-3', type: 'contact', content: { heading: 'Book Appointment' }}
    ]
  },

  // 4. Real Estate
  {
    id: 'realestate',
    category: 'Real Estate',
    name: 'Real Estate Agency',
    description: 'For real estate agents and property listings',
    preview: '🏠',
    color: '#3b82f6',
    sections: [
      { id: 'hero-4', type: 'hero', content: { heading: 'Find Your Dream Home', subheading: 'Trusted real estate services since 1995', buttonText: 'Browse Properties', buttonLink: '#gallery', backgroundImage: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'features-2', type: 'features', content: { heading: 'Why Choose Us', features: [{ icon: '🏆', title: 'Award Winning', description: 'Top agency 5 years' }, { icon: '💼', title: 'Expert Agents', description: '20+ professionals' }, { icon: '🤝', title: 'Trusted Service', description: '1000+ happy clients' }]}},
      { id: 'gallery-3', type: 'gallery', content: { heading: 'Featured Properties' }},
      { id: 'services-4', type: 'services', content: { heading: 'Our Services', items: [{ icon: '🏘️', title: 'Residential', description: 'Homes & apartments' }, { icon: '🏢', title: 'Commercial', description: 'Offices & retail' }, { icon: '📊', title: 'Investment', description: 'Property consulting' }]}},
      { id: 'testimonials-3', type: 'testimonials', content: { heading: 'Client Success Stories' }},
      { id: 'contact-4', type: 'contact', content: { heading: 'Contact Our Agents' }}
    ]
  },

  // 5. Law Firm
  {
    id: 'lawfirm',
    category: 'Legal Services',
    name: 'Law Firm',
    description: 'Professional website for lawyers and legal services',
    preview: '⚖️',
    color: '#1f2937',
    sections: [
      { id: 'hero-5', type: 'hero', content: { heading: 'Expert Legal Representation', subheading: 'Protecting your rights since 1985', buttonText: 'Free Consultation', buttonLink: '#contact', backgroundImage: 'https://images.pexels.com/photos/5668772/pexels-photo-5668772.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'services-5', type: 'services', content: { heading: 'Practice Areas', items: [{ icon: '👨‍⚖️', title: 'Criminal Defense', description: 'Expert representation' }, { icon: '🏢', title: 'Corporate Law', description: 'Business legal services' }, { icon: '👪', title: 'Family Law', description: 'Divorce & custody' }]}},
      { id: 'about-2', type: 'about', content: { heading: 'About Our Firm', text: 'With over 35 years of experience, we provide exceptional legal services with integrity and dedication.' }},
      { id: 'team-2', type: 'team', content: { heading: 'Our Attorneys' }},
      { id: 'testimonials-4', type: 'testimonials', content: { heading: 'Client Testimonials' }},
      { id: 'faq-1', type: 'faq', content: { heading: 'Legal FAQs' }},
      { id: 'contact-5', type: 'contact', content: { heading: 'Schedule Consultation' }}
    ]
  },

  // 6. E-commerce Store
  {
    id: 'ecommerce',
    category: 'E-commerce',
    name: 'Online Store',
    description: 'Perfect for online shops and product businesses',
    preview: '🛍️',
    color: '#10b981',
    sections: [
      { id: 'hero-6', type: 'hero', content: { heading: 'Shop Our Latest Collection', subheading: 'Free shipping on orders over $50', buttonText: 'Shop Now', buttonLink: '#gallery', backgroundImage: 'https://images.pexels.com/photos/1005058/pexels-photo-1005058.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'features-3', type: 'features', content: { heading: 'Why Shop With Us', features: [{ icon: '🚚', title: 'Free Shipping', description: 'On orders $50+' }, { icon: '↩️', title: 'Easy Returns', description: '30-day guarantee' }, { icon: '💳', title: 'Secure Payment', description: 'SSL encrypted' }]}},
      { id: 'gallery-4', type: 'gallery', content: { heading: 'Trending Products' }},
      { id: 'testimonials-5', type: 'testimonials', content: { heading: 'Customer Reviews' }},
      { id: 'newsletter-2', type: 'newsletter', content: { heading: 'Get Exclusive Deals' }},
      { id: 'contact-6', type: 'contact', content: { heading: 'Customer Support' }}
    ]
  },

  // 7. Photography Portfolio
  {
    id: 'photography',
    category: 'Creative',
    name: 'Photography',
    description: 'Stunning portfolio for photographers',
    preview: '📸',
    color: '#8b5cf6',
    sections: [
      { id: 'hero-7', type: 'hero', content: { heading: 'Capturing Life\'s Moments', subheading: 'Professional photography services', buttonText: 'View Portfolio', buttonLink: '#gallery', backgroundImage: 'https://images.pexels.com/photos/1264210/pexels-photo-1264210.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'about-3', type: 'about', content: { heading: 'About the Artist', text: 'Award-winning photographer with 15 years of experience in wedding, portrait, and commercial photography.' }},
      { id: 'gallery-5', type: 'gallery', content: { heading: 'Featured Work' }},
      { id: 'services-6', type: 'services', content: { heading: 'Services', items: [{ icon: '💒', title: 'Weddings', description: 'Full day coverage' }, { icon: '👨‍👩‍👧', title: 'Portraits', description: 'Family & individual' }, { icon: '🏢', title: 'Commercial', description: 'Product & corporate' }]}},
      { id: 'pricing-3', type: 'pricing', content: { heading: 'Photography Packages' }},
      { id: 'testimonials-6', type: 'testimonials', content: { heading: 'Client Love' }},
      { id: 'contact-7', type: 'contact', content: { heading: 'Book a Session' }}
    ]
  },

  // 8. Consulting Agency
  {
    id: 'consulting',
    category: 'Business Services',
    name: 'Consulting Firm',
    description: 'Professional consulting and advisory services',
    preview: '💼',
    color: '#0ea5e9',
    sections: [
      { id: 'hero-8', type: 'hero', content: { heading: 'Strategic Business Solutions', subheading: 'Expert consulting for growing companies', buttonText: 'Get Started', buttonLink: '#services', backgroundImage: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'features-4', type: 'features', content: { heading: 'Our Approach' }},
      { id: 'services-7', type: 'services', content: { heading: 'Services', items: [{ icon: '📊', title: 'Strategy', description: 'Business planning' }, { icon: '💹', title: 'Growth', description: 'Scaling solutions' }, { icon: '🔍', title: 'Analysis', description: 'Market research' }]}},
      { id: 'stats-1', type: 'stats', content: { heading: 'Our Impact' }},
      { id: 'team-3', type: 'team', content: { heading: 'Meet Our Consultants' }},
      { id: 'testimonials-7', type: 'testimonials', content: { heading: 'Client Success' }},
      { id: 'contact-8', type: 'contact', content: { heading: 'Schedule Meeting' }}
    ]
  },

  // 9. Medical/Dental Practice
  {
    id: 'medical',
    category: 'Healthcare',
    name: 'Medical Practice',
    description: 'Professional website for healthcare providers',
    preview: '⚕️',
    color: '#06b6d4',
    sections: [
      { id: 'hero-9', type: 'hero', content: { heading: 'Caring for Your Health', subheading: 'Comprehensive medical care for your family', buttonText: 'Book Appointment', buttonLink: '#contact', backgroundImage: 'https://images.pexels.com/photos/4386466/pexels-photo-4386466.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'services-8', type: 'services', content: { heading: 'Our Services', items: [{ icon: '🩺', title: 'Primary Care', description: 'General medicine' }, { icon: '💉', title: 'Preventive Care', description: 'Vaccinations' }, { icon: '🔬', title: 'Diagnostics', description: 'Lab services' }]}},
      { id: 'about-4', type: 'about', content: { heading: 'About Our Practice', text: 'Providing compassionate, quality healthcare to our community for over 20 years.' }},
      { id: 'team-4', type: 'team', content: { heading: 'Our Medical Team' }},
      { id: 'faq-2', type: 'faq', content: { heading: 'Common Questions' }},
      { id: 'contact-9', type: 'contact', content: { heading: 'Contact Us' }}
    ]
  },

  // 10. Tech Startup
  {
    id: 'techstartup',
    category: 'Technology',
    name: 'Tech Startup',
    description: 'Modern website for tech companies and SaaS',
    preview: '🚀',
    color: '#6366f1',
    sections: [
      { id: 'hero-10', type: 'hero', content: { heading: 'Innovate. Disrupt. Scale.', subheading: 'Next-generation solutions for modern businesses', buttonText: 'Get Started', buttonLink: '#pricing', backgroundImage: 'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=1920' }},
      { id: 'features-5', type: 'features', content: { heading: 'Why Choose Our Platform' }},
      { id: 'stats-2', type: 'stats', content: { heading: 'Trusted by Thousands' }},
      { id: 'services-9', type: 'services', content: { heading: 'Solutions', items: [{ icon: '☁️', title: 'Cloud Platform', description: 'Scalable infrastructure' }, { icon: '🔐', title: 'Security', description: 'Enterprise-grade' }, { icon: '📈', title: 'Analytics', description: 'Real-time insights' }]}},
      { id: 'pricing-4', type: 'pricing', content: { heading: 'Simple Pricing' }},
      { id: 'testimonials-8', type: 'testimonials', content: { heading: 'Customer Stories' }},
      { id: 'faq-3', type: 'faq', content: { heading: 'FAQs' }},
      { id: 'newsletter-3', type: 'newsletter', content: { heading: 'Stay Updated' }},
      { id: 'contact-10', type: 'contact', content: { heading: 'Talk to Sales' }}
    ]
  }
];

// Group templates by category
export const TEMPLATE_CATEGORIES = {
  'Food & Dining': ['restaurant'],
  'Health & Fitness': ['fitness'],
  'Beauty & Wellness': ['beauty'],
  'Real Estate': ['realestate'],
  'Legal Services': ['lawfirm'],
  'E-commerce': ['ecommerce'],
  'Creative': ['photography'],
  'Business Services': ['consulting'],
  'Healthcare': ['medical'],
  'Technology': ['techstartup']
};
